export const TABLE_NAME = 'Samples';
